import { Box, HStack } from "@chakra-ui/react";
import _ from "lodash";
import { VerificationTag } from "src/components/DataDisplay/VerificationTag";
import { ColumnDefWithTooltip } from "src/components/Table/Table";
import { Glossary } from "src/components/Text/Glossary";
import { GlossaryFn } from "src/types/glossary";
import * as GQL from "src/types/graphql";
import { VerificationResult } from "../types";
import { ColumnId } from "./constants";

type VerificationsColumnDefConfig = {
  formTemplate?: GQL.FormTemplateFragment;
  glossary: GlossaryFn;
};

type Row = {
  form: {
    verificationResults: VerificationResult[];
  };
};
export function buildVerificationsColumnDef<T extends Row>({
  formTemplate,
  glossary,
}: VerificationsColumnDefConfig): ColumnDefWithTooltip<T> {
  return {
    accessorFn: (row) => row.form.verificationResults,
    id: ColumnId.Verifications,
    header: () => <Glossary>Verifications</Glossary>,
    headerText: glossary`Verifications`,

    cell: (props) => {
      const vTags = _.sortBy(
        formTemplate?.form_verifications,
        (verifications) => verifications.label
      ).map((verification, index) => {
        const result = props.row.original.form.verificationResults.find(
          (result) => result.verificationId === verification.id
        );

        return (
          <Box key={index}>
            <VerificationTag
              status={
                result?.verificationStatus ??
                GQL.verification_status_enum.Pending
              }
              label={verification.label}
            />
          </Box>
        );
      });

      return <HStack>{vTags}</HStack>;
    },
  };
}
